//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('travelExpence', {
//        templateUrl: 'views/components/views/travelExpence/travelExpence.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'utilityService', 'modalService', 'translateService', 'travelExpenceService', 'economyService', function ($stateParams, stateService, utilityService, modalService, translateService, travelExpenceService, economyService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let travelBillNo = $stateParams.travelbill_no;
//            let travelExpenceNo = $stateParams.travelexpence_keyno;
            
//            let translations = {
//                confirm_title: '',
//                confirm_message: '',
//                confirm_ok_label: '',
//                confirm_cancel_label: '',
//                error: '',
//                ok: ''
//            };
            
//            vm.model = {
//                trexTypeButtons: [
//                    { id: 'list', icon: 'fa fa-bars', color: 'primary', type: 'primary', onClick: () => stateService.go('travexptypes', {}) }
//                ],
//                edit: {},
//                selectListExpenceTypes: [],
//                selectListCurrencies: [],
//                lockedSave: false,
//                lockedDelete: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATION FUNCTION

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATION FUNCTION

//            // #region LOAD PROCEDURE CALLS

//            async function loadEdit() {
//                vm.model.edit = (await travelExpenceService.getTravelExpence({
//                    travelbill_no: travelBillNo,
//                    travelexpence_keyno: travelExpenceNo
//                }))[0];
//            }

//            async function loadCurrencies() {
//                vm.model.selectListCurrencies = await economyService.listCurrencies();
//            }
            
//            async function loadExpenceTypes() {
//                if (utilityService.validateParmsValue(vm.model.edit.travelbill_no) !== true) return;
//                if (utilityService.validateParmsValue(vm.model.edit.travelexpence_keyno) !== true) return;
                
//                return vm.model.selectListExpenceTypes = await travelExpenceService.listExpenceTypes({
//                    travelbill_no: vm.model.edit.travelbill_no,
//                    travelexpence_keyno: vm.model.edit.travelexpence_keyno
//                });
//            }
            
//            async function retrieveCurrencyExRate() {
//                if (utilityService.validateParmsValue(vm.model.edit.base_valuta_id) !== true) return;
//                if (utilityService.validateParmsValue(vm.model.edit.valuta_id) !== true) return;
                
//                const response = (await travelExpenceService.getCurrencyExRate({
//                    valuta_id: vm.model.edit.base_valuta_id,
//                    currency_id: vm.model.edit.valuta_id,
//                    currencytype_keyno: '1'
//                }))[0];

//                vm.model.edit.exchangerate = response?.exchangerate;
//            }
            
//            async function retrieveExchangeFactor() {
//                if (utilityService.validateParmsValue(vm.model.edit.valuta_id) !== true) return;
//                if (utilityService.validateParmsValue(vm.model.edit.exchangerate) !== true) return;
                
//                const response = (await travelExpenceService.getExchangeFactor({
//                    currency_id: vm.model.edit.valuta_id,
//                    exchangerate: vm.model.edit.exchangerate
//                }))[0];

//                vm.model.edit.exchangefactor = response?.exchangerate_factor;
//            }

//            // #endregion LOAD PROCEDURE CALLS

//            // #region CALCULATION FUNCTIONS
            
//            function recalcAmount() {
//                //console.log('recalcAmount');
//                vm.model.edit.amount = utilityService.parseNumber(vm.model.edit.amountinvaluta) * utilityService.parseNumber(vm.model.edit.exchangerate);
//                //console.dir(vm.model.edit.amount);
//            }
            
//            function recalcExchangeFactor() {
//                //console.log('recalcExchangeFactor');
//                vm.model.edit.amount = utilityService.parseNumber(vm.model.edit.amountinvaluta) * utilityService.parseNumber(vm.model.edit.exchangefactor);
//                //console.dir(vm.model.edit.amount);
//            }

//            // #endregion CALCULATION FUNCTIONS

//            // #region MULTI DIRECTION BUTTON FUNCTIONS

//            vm.goToFunc = function (state, e) {
//                function go(parms) {
//                    if (e?.ctrlKey) {
//                        stateService.newTab(state, parms);
//                    } else {
//                        stateService.go(state, parms);
//                    }
//                }
                
//                travelExpenceService.saveObj(vm.model.edit).then(function (response) {
//                    if (response[0].errorcode !== '0') {
//                        modalService.show({
//                            type: 'warning',
//                            title: translations.error,
//                            message: response[0].errormessage,
//                            buttons: [{
//                                label: translations.ok,
//                                cssClass: 'btn-warning',
//                                action: function (dialogItself) {
//                                    dialogItself.close();
//                                    vm.model.lockedSave = false;
//                                }
//                            }]
//                        });
//                    } else {
//                        switch (state) {
//                            case 'pictures':
//                            case 'documents':
//                                go({
//                                    argtype: 'travelexpence_keyno',
//                                    argvalue: vm.model.edit.travelexpence_keyno
//                                });
//                                break;
//                            default:
//                                break;
//                        }
//                    }
//                });
//            }

//            // #endregion MULTI DIRECTION BUTTON FUNCTIONS

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                travelExpenceService.saveObj(vm.model.edit).then(function (response) {
//                    if (response[0].errorcode !== '0') {
//                    	modalService.show({
//                    		type: 'warning',
//                    		title: translations.error,
//                    		message: response[0].errormessage,
//                    		buttons: [{
//                    			label: translations.ok,
//                    			cssClass: 'btn-warning',
//                    			action: function (dialogItself) {
//                    				dialogItself.close();
//                    				vm.model.lockedSave = false;
//                    			}
//                    		}]
//                    	});
//                    } else {
//                    	vm.model.lockedSave = false;
//                    	stateService.back();
//                    }
//                });
//            }

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region BUTTON DELETE PROCEDURE FUNCTION CALL

//            vm.deleteValues = function () {
//                modalService.confirm({
//                    type: 'danger',
//                    title: translations.confirm_title,
//                    message: translations.confirm_message,
//                    okLabel: translations.confirm_ok_label,
//                    cancelLabel: translations.confirm_cancel_label
//                }).then(() => {
//                    travelExpenceService.deleteItem(vm.model.edit).then((response) => {
//                        if (response[0].errorcode !== '0') {
//                            modalService.show({
//                                type: 'warning',
//                                title: translations.error,
//                                message: response[0].errormessage,
//                                buttons: [{
//                                    label: translations.ok,
//                                    cssClass: 'btn-warning',
//                                    action: function (dialogItself) {
//                                        dialogItself.close();
//                                        vm.model.lockedDelete = false;
//                                    }
//                                }]
//                            });
//                        } else {
//                            vm.model.lockedDelete = false;
//                            stateService.back();
//                        }
//                    });
//                }, () => vm.model.lockedDelete = false);
//            }

//            // #endregion BUTTON DELETE PROCEDURE FUNCTION CALL

//            // #region FIELD CHANGE MULTI FUNCTIONS

//            vm.onChanged = function (value, id) {
//                switch (id) {
//                    case 'valuta_id':
//                        if (utilityService.validateWatchValue(value, vm.model.edit.valuta_id) !== true) return;

//                        vm.model.edit.valuta_id = value;

//                        if (utilityService.validateParmsValue(vm.model.edit.valuta_id, true) !== true) return;

//                        retrieveCurrencyExRate();
//                        break;
//                    case 'amountinvaluta':
//                        if (utilityService.validateWatchValue(value, vm.model.edit.amountinvaluta) !== true) return;

//                        vm.model.edit.amountinvaluta = value;

//                        if (utilityService.validateParmsValue(vm.model.edit.amountinvaluta, true) !== true) return;

//                        recalcAmount();
//                        recalcExchangeFactor();
//                        break;
//                    case 'exchangerate':
//                        if (utilityService.validateWatchValue(value, vm.model.edit.exchangerate) !== true) return;

//                        vm.model.edit.exchangerate = value;

//                        if (utilityService.validateParmsValue(vm.model.edit.exchangerate, true) !== true) return;
                        
//                        retrieveExchangeFactor();
//                        break;
//                    case 'exchangefactor':
//                        if (utilityService.validateWatchValue(value, vm.model.edit.exchangefactor) !== true) return;

//                        vm.model.edit.exchangefactor = value;

//                        if (utilityService.validateParmsValue(vm.model.edit.exchangefactor, true) !== true) return;

//                        recalcExchangeFactor();
//                        break;
//                    default:
//                        utilityService.setValueToVariable(value);
//                        break;
//                }
//            };

//            // #endregion FIELD CHANGE MULTI FUNCTIONS
            
//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                translate();
//                await loadEdit();
//                loadCurrencies();
//                loadExpenceTypes();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
